import React from 'react';
import { useDispatch } from 'react-redux';
import { searchFacetChange } from '../Actions/FacetedSearch.action';
import { translate } from '../Services/translation';

const getRemoveFilterLabel = (label) =>
    translate('facet.filter.remove.label').replace('{0}', label);

const FilterTags = ({ facetFilters, navigationTheme }) => {
    const dispatch = useDispatch();

    const selectedFacetGroup = facetFilters.filter(
        (filter) => filter.selectedOptions.length > 0
    );
    const selectedFacetOption = selectedFacetGroup.reduce(
        (accumulator, group) => {
            if (!group) {
                return accumulator;
            }
            const { options, selectedOptions } = group;
            const groupOptions = [];

            for (const val of options) {
                if (group.isSlider) {
                    groupOptions.push({ ...val, group });
                    break;
                } else if (selectedOptions.includes(val.id)) {
                    groupOptions.push({ ...val, group });
                }
            }
            return [...accumulator, ...groupOptions];
        },
        []
    );
    return selectedFacetGroup.length === 0 ? null : (
        <div className="selected-filter">
            {navigationTheme === 'category' && (
                <span>
                    <span>{translate('search.yourfilter')}: </span>
                    {selectedFacetOption &&
                        selectedFacetOption.map((option, index) => {
                            const label = option.group.isSlider
                                ? getSliderQueryValues(option)
                                : option.label;

                            return (
                                <button
                                    type="button"
                                    className="selected-filter__tag"
                                    aria-label={getRemoveFilterLabel(label)}
                                    onClick={() =>
                                        dispatch(
                                            searchFacetChange(
                                                option.group,
                                                option,
                                                true
                                            )
                                        )
                                    }
                                    key={`option-${index}`}
                                >
                                    {label}
                                </button>
                            );
                        })}
                </span>
            )}
        </div>
    );
};

const getSliderQueryValues = (option) => {
    const query = new URLSearchParams(window.location.search);
    const hasSliderParam = query.has(option.group.id);
    const querySliderParam = query.get(option.group.id);

    if (hasSliderParam && querySliderParam) {
        return querySliderParam;
    }

    return option.label;
}


export default FilterTags;
